import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE,

    ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR,
    ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER,

    TrialGroupLaboratoryPersonnelAction
} from '../actions/trialGroupLaboratoryPersonnels';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialGroupLaboratoryPersonnelState {
    formData: Dtos.TrialGroupLaboratoryPersonnel | Dtos.TrialGroupLaboratoryPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialGroupLaboratoryPersonnel[];
    formLength: number;
}

const initialState: ITrialGroupLaboratoryPersonnelState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialGroupLaboratoryPersonnelState, _isLoading: boolean): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialGroupLaboratoryPersonnelState,
    formData: Dtos.TrialGroupLaboratoryPersonnel | Dtos.TrialGroupLaboratoryPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialGroupLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialGroupLaboratoryPersonnelState, formFilter: IFormFilter): ITrialGroupLaboratoryPersonnelState {

    const items: Dtos.TrialGroupLaboratoryPersonnel[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.personnel?.displayWithSalutation?.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialGroupLaboratoryPersonnelState, propertiesToClear?: string[]): ITrialGroupLaboratoryPersonnelState {

    if (!propertiesToClear) {
        const newState: ITrialGroupLaboratoryPersonnelState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialGroupLaboratoryPersonnelState, _isSaving: boolean): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialGroupLaboratoryPersonnelState,
    formData: Dtos.TrialGroupLaboratoryPersonnel | Dtos.TrialGroupLaboratoryPersonnel[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialGroupLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialGroupLaboratoryPersonnelState, _isCreating: boolean): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialGroupLaboratoryPersonnelState,
    formData: Dtos.TrialGroupLaboratoryPersonnel,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialGroupLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialGroupLaboratoryPersonnelState, _isValidating: boolean): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialGroupLaboratoryPersonnelState,
    formData: Dtos.TrialGroupLaboratoryPersonnel,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialGroupLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelState {
    const newState: ITrialGroupLaboratoryPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialGroupLaboratoryPersonnelReducer: Reducer<ITrialGroupLaboratoryPersonnelState> = (state: ITrialGroupLaboratoryPersonnelState = initialState, action: TrialGroupLaboratoryPersonnelAction) => {
    switch (action.type) {
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD:
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID:
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID:
            return loading(state, true);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE:
            return saving(state, true);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE:
            return creating(state, true);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialGroupLaboratoryPersonnelReducer;